import { render, staticRenderFns } from "./BaseGraph.vue?vue&type=template&id=8c286ad0"
import script from "./BaseGraph.vue?vue&type=script&lang=js"
export * from "./BaseGraph.vue?vue&type=script&lang=js"
import style0 from "vue-ads-pagination/dist/vue-ads-pagination.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./BaseGraph.vue?vue&type=style&index=1&id=8c286ad0&prod&lang=scss"
import style2 from "./BaseGraph.vue?vue&type=style&index=2&id=8c286ad0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports